import { createContext, useContext, useState } from "react";
import { requestWithToken } from "../utils/apis";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => Boolean(localStorage.getItem("token"))
  );
  const [user, setUser] = useState({});

  const fetchUserDetails = async (redirectAfterLoad = false) => {
    const result = await requestWithToken("GET", "/api/user/me");
    console.log(result, "res")
    if (result?.data?.status === 0) {
      // localStorage.removeItem("token");
      // window.location.href = "/login";
      return;
    }
    if (result?.status === 200) {
      setUser(result.data.data);
      if (redirectAfterLoad) {
        navigate("/blogs");
      }
    }
  };

  const login = (redirectAfterLoad = true) => {
    fetchUserDetails(redirectAfterLoad)
    setIsAuthenticated(true)
  };
  const logout = () => {
    setIsAuthenticated(false)
    // localStorage.removeItem("token")
       localStorage.clear();
    sessionStorage.clear();
    
  };


  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
